import { jsx as _jsx } from "react/jsx-runtime";
import { Container } from "../Container";
export function Chevron() {
    return (_jsx(Container, { children: _jsx("polygon", { points: "9 14.84 0 5.84 2.681 3.16 9 9.479 15.319 3.16 18 5.84 9 14.84", fill: "currentColor" }, void 0) }, void 0));
}
//# sourceMappingURL=Chevron.js.map